window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}


const customizeInitQI = (checkoutElements) => {
   try {
     if (!document.querySelector('bss-qo') && typeof BSS_B2B == 'object') {
       BSS_B2B.qi = { code: "qi", status: false };
       BSS_B2B.ol = { code: "ol", status: false };
     }
   } catch (error) {
     
   }
    return checkoutElements
}

window.BSS_B2B.addFilter('custom:cart/checkout_ele', customizeInitQI)


document.addEventListener('DOMContentLoaded', (event) => {
    setTimeout(() => {
        let form = document?.querySelector("[bss-b2b-main-product-form]");
        if (form) {
            const plusBtn = form?.querySelector("[bss-b2b-btn-up-quantity]");
        const downBtn = form?.querySelector("[bss-b2b-btn-down-quantity]");
        const quantity = document?.querySelector("[bss-b2b-main-product-form] .outer-spin-button");
        let store = BSS_B2B?.storage?.variantStorage?.store;
        const firstVariant = store?.values()?.next()?.value;

        if (firstVariant.appliedQI) {
            quantity.setAttribute('min', firstVariant.appliedQI.qty_increment_min);
            quantity.setAttribute('step', firstVariant.appliedQI.qty_increment);
            plusBtn.setAttribute("@click.prevent", `plus(${firstVariant.appliedQI.qty_increment})`);
            downBtn.setAttribute("@click.prevent", `minus(${firstVariant.appliedQI.qty_increment})`);
        }
        }

    }, 2000);
});
const customHandleATC = (qiMessage) => {
  const atcButton = document.querySelector('.add_to_cart_button');
  if (atcButton) {
      atcButton.setAttribute('@click', '');
  }
  return qiMessage;
}
window.BSS_B2B.addFilter('custom:qi_message/productPage', customHandleATC);

const fixMissEventCheckout = () => {
  BSS_B2B.observer.cartSubject.listenCartCheckout();
}
window.BSS_B2B.addAction('custom:cart/delayCart', fixMissEventCheckout);

window.addEventListener('bss:cartCheckout', function (e) {
    if (
        typeof BSS_B2B === 'object' &&
        BSS_B2B !== null &&
        BSS_B2B.observer &&
        BSS_B2B.observer.cartSubject &&
        typeof BSS_B2B.observer.cartSubject.listenCartCheckout === 'function'
    ) {
        BSS_B2B.observer.cartSubject.listenCartCheckout();
    }
});

document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    BSS_B2B.observer.cartSubject.listenCartCheckout();
})

document.addEventListener("click", e => {
    if (e.target && e.target.closest(`#checkout-submit`)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
    }
}, 1);
(function () {
  'use strict';

  const NH = {
    BOX_SIZE: 240,
    CURRENCY: '฿',
    TABLE_SELECTOR: '.bss-b2b-cart-item-qty-table[bss-b2b-qb-product-table]',

    parseBssTable(tableEl) {
      const rows = tableEl.querySelectorAll('tbody tr, table tr');
      const tiers = [];
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length < 2) return;
        const rangeText = cells[0].textContent.trim();
        const priceText = cells[1].textContent.trim();
        const rangeMatch = rangeText.match(/(\d[\d,]*)\s*[-–]\s*(\d[\d,]*)|[≥>]=?\s*(\d[\d,]*)/);
        const priceMatch = priceText.match(/([\d,]+(?:\.\d+)?)/);
        if (!rangeMatch || !priceMatch) return;
        const from = parseInt((rangeMatch[1] || rangeMatch[3]).replace(/,/g, ''), 10);
        const price = parseFloat(priceMatch[1].replace(/,/g, ''));
        tiers.push({ from, price });
      });
      return tiers;
    },

    getRetailPrice() {
      const sel = [
        '[bss-b2b-main-product-form] [bss-b2b-product-id] span',
        '[bss-b2b-product-id] span',
        '.price-item--regular',
        '[data-product-price]'
      ].join(', ');
      const el = document.querySelector(sel);
      if (!el) return null;
      const m = el.textContent.match(/([\d,]+(?:\.\d+)?)/);
      return m ? parseFloat(m[1].replace(/,/g, '')) : null;
    },

    formatPrice(n) {
      return this.CURRENCY + Math.round(n).toLocaleString();
    },

    render(tableEl) {
      const tiers = this.parseBssTable(tableEl);
      if (tiers.length === 0) {
        tableEl.classList.add('nh-fallback');
        return;
      }
      tableEl.classList.remove('nh-fallback');

      const retail = this.getRetailPrice();

      const tiersHtml = tiers.map(t => {
        const boxCount = Math.max(1, Math.round(t.from / this.BOX_SIZE));
        const label = boxCount === 1 ? '1 Box' : boxCount + ' Box';
        let savingsHtml = '';
        if (retail && retail > t.price) {
          const totalSaved = Math.round((retail - t.price) * t.from);
          savingsHtml = '<div class="nh-savings">Save ' + this.formatPrice(totalSaved) + '</div>';
        }
        return ''
          + '<div class="nh-tier">'
          +   '<div class="nh-label">' + label + '</div>'
          +   '<div class="nh-units">' + t.from.toLocaleString() + ' units</div>'
          +   '<div class="nh-amount">' + this.formatPrice(t.price) + '</div>'
          +   savingsHtml
          + '</div>';
      }).join('');

      const wrapper = document.createElement('div');
      wrapper.className = 'nh-tier-display';
      wrapper.style.setProperty('--nh-cols', tiers.length);
      wrapper.innerHTML =
          '<p class="nh-intro"><strong>Buy more, save more.</strong> Mix any brand or product — your tier price applies to the entire order.</p>'
        + '<div class="nh-tier-card">' + tiersHtml + '</div>';

      const old = tableEl.parentNode.querySelector(':scope > .nh-tier-display');
      if (old) old.remove();
      tableEl.parentNode.insertBefore(wrapper, tableEl);
    },

    init() {
      const trySetup = () => {
        const tableEl = document.querySelector(this.TABLE_SELECTOR);
        if (!tableEl || !tableEl.querySelector('td')) return false;
        this.render(tableEl);
        if (!tableEl._nhObserved) {
          tableEl._nhObserved = true;
          let timer = null;
          const obs = new MutationObserver(() => {
            clearTimeout(timer);
            timer = setTimeout(() => this.render(tableEl), 100);
          });
          obs.observe(tableEl, { childList: true, subtree: true, characterData: true });
        }
        return true;
      };
      if (trySetup()) return;
      const bodyObs = new MutationObserver(() => {
        if (trySetup()) bodyObs.disconnect();
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => bodyObs.disconnect(), 15000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => NH.init());
  } else {
    NH.init();
  }
})();